// User access calls. Listing and role changes are the admin endpoints (backend:
// routes/access_routes.py, manage_users); granting and removing use the per-project member
// endpoints the Manage users modal uses, so a new person gets an invitation code the same way.
import axios from 'axios';
import { baseApi } from '../../API/api';
import { authHeaders } from '../../utils/authHeader';

export { apiError } from '../UserManagement/invitationsApi';

/** {assignments, projects, users, roles} */
export async function listAccess() {
  const { data } = await axios.get(`${baseApi}/api/admin/access`, { headers: await authHeaders() });
  return data;
}

export async function changeRole(projectId, userId, roleId) {
  const { data } = await axios.put(
    `${baseApi}/api/admin/access/projects/${projectId}/users/${userId}`,
    { role_id: roleId },
    { headers: await authHeaders() },
  );
  return data;
}

/** {user, invite_status, invitation}; a 409 with code USER_ALREADY_ASSIGNED if they have access. */
export async function grantAccess(projectId, email, roleId) {
  const { data } = await axios.post(
    `${baseApi}/api/projects/${projectId}/users`,
    { email, role_id: roleId },
    { headers: await authHeaders() },
  );
  return data;
}

export async function removeAccess(projectId, userId) {
  await axios.delete(`${baseApi}/api/projects/${projectId}/users/${userId}`, { headers: await authHeaders() });
}
